<template>
    <div class="logout">
        <div v-if="error">
            <div class="alert alert-danger">{{ error }}</div>
        </div>
        <template v-else>
            <p v-if="loggedIn">Ingelogd!</p>
            <p v-else>We controleren de inloggegevens</p>
        </template>

    </div>
</template>

<script>

export default {
    created() {
        this.login()
    },
    data() {
        return {
            error: false,
            loggedIn: false
        }
    },
    methods: {
        login() {
            this.resetForNewLogin()
            let idClient = this.$route.params.idClient || false;
            let token1 = this.$route.params.token1 || false;
            let token2 = this.$route.params.token2 || false;
            let token3 = this.$route.params.token3 || false;
            if (token1 && token2) {
                this.$request.post('/authentication/groepsapp/by-keys', {
                        idClient: idClient,
                        token1: token1,
                        token2: token2,
                        token3: token3
                    }
                ).then((response) => {
                    if (
                        response
                        &&
                        response.success
                        &&
                        response.success === true
                    ) {
                        this.$store.commit('SET_DEVICE_TOKEN', response.device_token)
                        this.$store.commit('SET_SESSION', {session_token: response.session_token})
                        this.$store.dispatch('loadApplicationSettings')
                        this.$router.push('/select-establishment')
                    } else {
                        this.error = response.message
                    }
                })
            }
        }
    }
}
</script>
